import React, { Component } from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import { localize } from '../util/Localizer'
import RBButton from '../controls/RBButton'
import { resetMessage } from '../redux/actions/logoutActions'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { multipleComputers } from '../assets/images'
import Footer from '../widgets/common/Footer'
import Isvg from 'react-inlinesvg'

class ServerError extends Component {
  constructor (props) {
    super(props)
    this.signIn = this.signIn.bind(this)
    // this.styleError = this.styleError.bind(this)
    this.animate = this.animate.bind(this)
    this.state = {}
  }

  animate () {
    this.setState({
      animateClass: 'moveUp'
    })
  }

  componentDidMount () {
    // Redirect to login page when there is no error to show, if the session is valid, it'll redirect to claims
    if (!this.props.error) {
      this.props.push('/')
    } else {
      setTimeout(this.animate, 200)
    }
  }

  signIn (e) {
    e.preventDefault()
    this.props.resetMessage()
    this.props.push('/')
  }

  render () {
    const error = (this.props.error && this.props.error.rawResponse && this.props.error.rawResponse.error_description) || '<b>Unknown Server Error<b><br><br><br>Unknown server error occured, please log in again.'
    let styled = error
    if (error.includes('timed out')) {
      styled = error.replace(/Your session has timed out./i, '<b>Your session has timed out.</b><br>')
    }
    if (error.includes('été interrompue.')) {
      styled = error.replace(/Votre session a été interrompue./i, '<b>Votre session a été interrompue.</b><br>')
    }
    if (error.includes('Multiple users accessing your Account.')) {
      styled = error.replace(/Multiple users accessing your Account./i, '<b>Multiple users accessing your Account.</b><br>')
    }
    if (error.includes('Plusieurs utilisateurs accèdent à votre compte.')) {
      styled = error.replace(/Plusieurs utilisateurs accèdent à votre compte./i, '<b>Plusieurs utilisateurs accèdent à votre compte.</b><br>')
    }
    if (error.includes('Access Denied')) {
      styled = error.replace(/Access Denied/i, '<b>Access Denied</b><br>')
    }
    if (error.includes('Accès refusé')) {
      styled = error.replace(/Accès refusé/i, '<b>Accès refusé</b><br>')
    }
    return (<div>
      <section className={'notFound ' + this.state.animateClass}>
        <Grid fluid>
          <Row middle='xs' >
            <Col xs={12} md={8} mdOffset={2} >
              <Isvg className='computer' src={multipleComputers} />
              <h3 dangerouslySetInnerHTML={{ __html: styled }} />
              { ((this.props.error && this.props.error.friendlyCode) || '').includes('10001008')
                ? <RBButton primary variant='contained' label={localize('pages.errorPage.SignIn')} onClick={this.signIn} />
                : <RBButton primary variant='contained' label={localize('common.backToHome')} onClick={this.signIn} />}
            </Col>
          </Row>
        </Grid>
      </section>
      <Footer />
    </div>)
  }
}

function mapStateToProps (state) {
  return {
    pageLoading: state.LogoutReducers.pageLoading,
    error: state.LogoutReducers.msg
  }
}

const ConnectedServerError = connect(mapStateToProps, { push, resetMessage })(ServerError)

export default ConnectedServerError



// WEBPACK FOOTER //
// ./src/components/ServerError.js